module.exports = __webpack_public_path__ + "media/images/landing/partner_logos/omg-493f3e5588909a313811542ea5b92352.png";